@if(true) {
<a class="button m-t"
   [routerLink]="'/signup'">
    <span class="no-wrap">{{'Join our VIP list'|translate}}</span>
</a>
}
